function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { Fragment, useState, useEffect } from 'react';
import { AddressSelectAutocomplete } from '@domain-group/fe-co-allhomes-autocomplete';
import { Stack } from '@domain-group/fe-blueprint-ui/layout';
import * as styles from './address-selector.style';
import { jsx as ___EmotionJSX } from "@emotion/core";
export var AddressSelector = _ref => {
  var handleAddress = _ref.handleAddress,
    initialAddress = _ref.initialAddress;
  var _useState = useState(initialAddress || null),
    _useState2 = _slicedToArray(_useState, 2),
    address = _useState2[0],
    setAddress = _useState2[1];
  useEffect(() => {
    handleAddress(address);
  }, [handleAddress, address]);
  return ___EmotionJSX(Fragment, null, ___EmotionJSX("div", {
    css: styles.text
  }, "To help you with an accurate free market appraisal from these local experts, please enter your address."), address ? ___EmotionJSX(Stack, {
    padding: "xs",
    css: styles.selectedAddressBox,
    gap: "xs"
  }, ___EmotionJSX("span", {
    css: styles.address
  }, address, ". "), ___EmotionJSX("button", {
    type: "button",
    css: styles.changeAddressLink,
    onClick: () => setAddress(null),
    onKeyUp: () => setAddress(null)
  }, "Change address")) : ___EmotionJSX("div", {
    css: styles.autocomplete
  }, ___EmotionJSX(AddressSelectAutocomplete, {
    onSelectionChange: selectedAddress => setAddress((selectedAddress === null || selectedAddress === void 0 ? void 0 : selectedAddress.name) || null)
  })));
};